import { memo, ReactNode } from "react";
import classNames from "classnames";
import NavbarContextProvider from "./NavbarContext/NavbarContextProvider";

import styles from "./style.module.scss";

export type NavbarProps = {
  className?: string,
  children?: ReactNode
}

export const Navbar = memo<NavbarProps>((
  {
    className,
    children,
  }) => {

  return (
    <NavbarContextProvider>
      <div className={classNames(className, styles.rootStyles, styles.root)}>
        {children}
      </div>
    </NavbarContextProvider>
  );
});

